<template>
  <RouterView />

  <Teleport to="body">
    <div class="toast-container">
      <TransitionGroup name="slide-fade">
        <ToastMessage
          v-for="toast in toastStore.toasts"
          :key="toast.id"
          :message="toast.message"
          :type="toast.type"
          @dismissed="toastStore.remove(toast.id)"
        />
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<script setup>
import { useToastStore } from '@/store';

import { ToastMessage } from '@/components/toasts';

const toastStore = useToastStore();
</script>
